import styled from "styled-components";

export const ProjectShowDetailContainer = styled.div`
  display: flex;
  gap: 20px;
`